import {PasskeyConfig} from "./passkey";
import {Box, IconButton, TextField} from "@mui/material";
import {PD_SM, PD_XSM, PD_XXSM, SZ_SMD, SZ_SSM} from "./dimens";
import {createRef, ReactElement, RefObject, useState} from "react";
import {CloseOutlined} from "@mui/icons-material";

export type PasskeyInputProps = {
  size?: "small" | "medium",
  style?: any,
  config: PasskeyConfig,
  passkey?: string,
  unprotected?: boolean,
  onPasskeyInputChanged?: (passkey: string) => void,
}

export function PasskeyInput(props: PasskeyInputProps): ReactElement {
  const initial = Array.from({length: props.config.length});
  initial.forEach((_, index: number) => initial[index] = props.passkey?.at(index));
  const refs: RefObject<HTMLInputElement>[] = Array.from({length: props.config.length});
  refs.forEach((_, index) => refs[index] = createRef<HTMLInputElement>());
  const [letters, setLetters] = useState(initial);
  const size = props.size || "medium";
  const smallSize = size === "small";
  const children = Array.from({length: props.config.length}).map((_, index: number) =>
    <TextField
      style={{width: smallSize ? SZ_SSM : SZ_SMD}}
      inputRef={refs[index]}
      type={"password"}
      inputMode={props.config.type === "numeric" ? "numeric" : "none"}
      onFocus={event => event.target.select()}
      autoFocus={index === 0}
      inputProps={{
        type: props.unprotected ? "text" : "password",
        inputMode: props.config.type === "numeric" ? "numeric" : "none",
        maxLength: 1,
        style: {padding: PD_XSM, fontSize: smallSize ? "100%" : "250%", fontWeight: "bold", textAlign: "center"},
      }}
      value={letters.at(index)}
      onChange={event => {
        const newLetters = [...letters];
        let value: string = event.target.value;
        const isAlpha = value.toUpperCase().charCodeAt(0) >= "A".charCodeAt(0) && value.toUpperCase().charCodeAt(0) <= "Z".charCodeAt(0);
        const isNumeric = value.charCodeAt(0) >= "0".charCodeAt(0) && value.charCodeAt(0) <= "9".charCodeAt(0);
        if (!((props.config.type.includes("alpha") && isAlpha) || (props.config.type.includes("numeric") && isNumeric))) {
          return;
        } else if (props.config.type.includes("upper")) {
          value = value.toUpperCase();
        } else if (props.config.type.includes("lower")) {
          value = value.toLowerCase();
        }
        newLetters[index] = value;
        setLetters(newLetters);
        props.onPasskeyInputChanged?.(newLetters.filter((letter: string) => letter?.length === 1).join(""));
        if (value?.length > 0 && index < props.config.length - 1) {
          const nextElement = refs[index + 1].current;
          // nextElement.select();
          nextElement.focus();
        }
      }}/>);
  return <Box style={{alignItems: "center", display: "flex", gap: smallSize ? PD_XXSM : PD_SM, ...props.style}}>
    {children}
    <IconButton onClick={() => setLetters(Array.from({length: props.config.length}).map(() => ""))}>
      <CloseOutlined/>
    </IconButton>
  </Box>
}
